import HttpUtil, { type PageResponse, type ResultResponse } from '@/api'

// 系统-职务
export type PageSettingResponse = {
    // 设置 ID
    id?: string
    // 名称
    name?: string
    // 是否启用：0=否，1=是
    isEnable?: number
    // 编码
    code?: string
    // 值
    value?: string
    // 排序
    sort?: number
    // 备注
    remark?: string
    // 创建人
    createUserId?: string
    // 创建人名称
    createUserName?: string
    // 创建时间
    createTime?: number
    // 更新人
    updateUserId?: string
    // 更新人名称
    updateUserName?: string
    // 更新时间
    updateTime?: number
}

// 系统-职务
export type AddSettingRequest = {
    // 名称
    name?: string
    // 是否启用：0=否，1=是
    isEnable?: number
    // 编码
    code?: string
    // 值
    value?: string
    sort?: number
    remark?: string
}

// 系统-职务
export type UpdateSettingRequest = {
    // 设置 ID
    id?: string
    // 名称
    name?: string
    // 是否启用：0=否，1=是
    isEnable?: number
    // 值
    value?: string
    // 排序
    sort?: number
    // 备注
    remark?: string
}

export type PageSettingRequest = {
    // 当前页
    pageNumber?: number
    // 每页大小
    pageSize?: number
    // 名称
    name?: string
    // 编码
    code?: string
}

// 系统-职务
export type GetSettingRequest = {
    // 职务 ID
    id?: string
}

export type DeleteSettingRequest = {
    // 职务 ID
    id?: string
}

export type ListSettingRequest = {
    // 编码数组
    codeList?: string[]
}

export type ListSettingResponse = {
    // 设置 ID
    id?: string
    // 名称
    name?: string
    // 是否启用：0=否，1=是
    isEnable?: number
    // 编码
    code?: string
    // 值
    value?: string
}

export type ExternalBaseSettingResponse = {
    // 名称
    name?: string
    // 编码
    code?: string
    // 值
    value?: string
    // 描述
    description?: string
}

// 系统-字典
export type GetSettingResponse = {
    // 设置 ID
    id?: string
    // 名称
    name?: string
    // 是否启用：0=否，1=是
    isEnable?: number
    // 编码
    code?: string
    // 值
    value?: string
    // 排序
    sort?: number
    // 备注
    remark?: string
}

export type MoveSettingRequest = {
    // 源 ID
    sourceId?: string
    // 目标 ID
    targetId?: string
}

export class Setting {
    static async externalBase() {
        return await HttpUtil.post<ResultResponse<ExternalBaseSettingResponse[]>>('/external/system/setting/base', {})
    }

    static async add(request: AddSettingRequest) {
        return await HttpUtil.post<ResultResponse>('/system/setting/add', request)
    }

    static async get(request: GetSettingRequest) {
        return await HttpUtil.post<ResultResponse<GetSettingResponse>>('/system/setting/get', request)
    }

    static async update(request: UpdateSettingRequest) {
        return await HttpUtil.post<ResultResponse>('/system/setting/update', request)
    }

    static async remove(request: DeleteSettingRequest) {
        return await HttpUtil.post<ResultResponse>('/system/setting/delete', request)
    }

    static async list(request: ListSettingRequest) {
        return await HttpUtil.post<ResultResponse<ListSettingResponse[]>>('/system/setting/list', request)
    }

    static async page(request: PageSettingRequest) {
        return await HttpUtil.post<ResultResponse<PageResponse<PageSettingResponse>>>('/system/setting/page', request)
    }
}
